import { render, staticRenderFns } from "./AddOrEditGeograficForm.vue?vue&type=template&id=3378d404"
import script from "./AddOrEditGeograficForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditGeograficForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditGeograficForm.vue?vue&type=style&index=0&id=3378d404&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports